import { memo, forwardRef } from 'react';

export const genericMemo: <T extends keyof JSX.IntrinsicElements | React.JSXElementConstructor<any>>(
  component: T,
  propsAreEqual?: (prevProps: React.ComponentProps<T>, nextProps: React.ComponentProps<T>) => boolean,
) => T & { displayName?: string } = memo;

export function forwardRefMemo<TElement, TProps = unknown>(render: React.ForwardRefRenderFunction<TElement, TProps>) {
  return memo(forwardRef(render)) as React.MemoExoticComponent<
    React.ForwardRefExoticComponent<TProps & React.RefAttributes<TElement>>
  >;
}
